import React from 'react';
import { TextBox, Switch, DatePicker, EmailBox, MaskedBox, PercentageBox, CheckBox } from 'fw/forms';
import { Label, Tooltip } from 'fw/components';
import { Row, Col, FormGroup, Button, Glyphicon } from 'react-bootstrap';
import { GenderCombo, ServiceBranchCombo, EthnicityCombo, PhoneBox, DocumentUpload, SdvetNotice } from 'areas/shared/controls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronDown, faChevronRight, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import * as Modals from 'fw/globals/Modals';
import API from 'fw/system/API';
import Moment from 'moment';
import { TooltipCode } from 'areas/shared/consts';

class VeteranOwnerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = props => {
        return {
            form: {
                veteranOwnerList: props.veteranOwnerList,
                ownersUpdatedFlagged: props.ownersUpdatedFlagged
            },
            tooltips: props.tooltips,
            formSF180StorageToken: props.formSF180StorageToken,
            formSF180fileName: props.formSF180fileName,
        };
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.veteranOwnerList instanceof Array || this.state.form.ownersUpdatedFlagged !== nextProps.ownersUpdatedFlagged) {
            this.setState({
                form: {
                    veteranOwnerList: nextProps.veteranOwnerList,
                    ownersUpdatedFlagged: nextProps.ownersUpdatedFlagged
                }
            });
        }
    }

    handleOwnerResumeUploadChange = (index, value) => {
        var item = this.state.form.veteranOwnerList[index];
        item.ownerResumeStorageToken = value.storageToken;
        item.ownerResumeFileName = value.fileName;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    onClickDetails(index) {
        var item = this.state.form.veteranOwnerList[index];
        item.veteranDetailHide = !item.veteranDetailHide;

		this.props.onUpdateVeteranOwnerList(index, item);
	}

    handleNonVeteranContributionsUploadChange = (index, value) => {
        var item = this.state.form.veteranOwnerList[index];
        item.nonVeteranContributionsStorageToken = value.storageToken;
        item.nonVeteranContributionsFileName = value.fileName;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleSF180UploadChange = (index, value) => {
        var item = this.state.form.veteranOwnerList[index];
        item.sF180StorageToken = value.storageToken;
        item.sF180FileName = value.fileName;

        if (!value.storageToken)
            item.sF180Confirmation = false;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleConfirmF180 = (index, value) => {
        var item = this.state.form.veteranOwnerList[index];
        item.sF180Confirmation = value;
        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleCitizenshipProofUploadChange = (index, value) => {
        var item = this.state.form.veteranOwnerList[index];
        item.citizenshipProofStorageToken = value.storageToken;
        item.citizenshipProofFileName = value.fileName;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    handleBenefitVerificationLetterUploadChange = (index, value) => {
        var item = this.state.form.veteranOwnerList[index];
        item.benefitVerificationLetterStorageToken = value.storageToken;
        item.benefitVerificationLetterFileName = value.fileName;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    onDeleteVeteranOwner(index) {
        let me = this;
        Modals.confirm(
            "You are about to Delete this Owner. This Owner will no longer be linked to this company if you proceed. <br /><br />" +
            "If you wish to retain this Owner, please select 'No', and you will be returned to the previous screen. <br /><br />" +
            "If you wish to remove this Owner, please select 'Yes'.",
            function () {
                me.props.onDeleteVeteranOwner(index);
            }
        );
    }

    onUpdateAddVeteranOwner = (index, value) => {
        var item = this.state.form.veteranOwnerList[index];
        item.description = value;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    onChange = (index, value, controlName) => {
        var item = this.state.form.veteranOwnerList[index];
        item[controlName] = value;

        if (controlName === 'isOwnerVeteran')
            this.checkBlankIsOwnerFields(item);
        if (controlName === 'veteranServiceConnectedDisabled')
            this.checkBlankDisabledUpload(item);

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    onDateBlur = (index, value, controlName) => {
        if (value === "")
            return;
            
        var date = Moment(value, ["D MMM YYYY", "DD MMM YYYY"], true);

        if (!date.isValid())
        {
            var item = this.state.form.veteranOwnerList[index];
            item[controlName] = "";
            this.refs[`${controlName}_${index}`].setValue("");
            this.props.onUpdateVeteranOwnerList(index, item);
        }
    }

    onHeldPercentBlur = (index, value, controlName) => {
        if (!this.props.isRenewal)
            return;

        var item = this.state.form.veteranOwnerList[index];
        var originalValue = this.getPercentNumber(item.businessHeldPercentFromOriginalApp);
        var newValue = this.getPercentNumber(value);

        if (!this.state.form.ownersUpdatedFlagged && !item.fromRenewal && originalValue !== newValue)
            this.props.showOwnerUpdatedPopup();
    }

    getPercentNumber(v) {
        let percent = `${v !== null ? v : ""}`;

        // Replace every $ character generated from CurrencyBox
        percent = percent
            .replace('%', '');
        
        percent = percent
            .replace('.00', '');

        return percent;
    }

    checkBlankDisabledUpload = (item) => {
        if (!item.veteranServiceConnectedDisabled){
            item.benefitVerificationLetterStorageToken = null;
            item.benefitVerificationLetterFileName = null;
        }
    }

    checkBlankIsOwnerFields = (item) => {   
        if (!item.isOwnerVeteran){
            item.serviceBranchId = null;
            item.sF180SentDate = null;
            item.birthday = null;
            item.sF180Confirmation = false;
            item.veteranServiceConnectedDisabled = false;
            item.sF180StorageToken = null;
            item.sF180FileName = null;
            item.citizenshipProofStorageToken = null;
            item.citizenshipProofFileName = null;
            item.benefitVerificationLetterStorageToken = null;
            item.benefitVerificationLetterFileName = null;
        }
        else{
            item.nonVeteranContributionsStorageToken = null;
            item.nonVeteranContributionsFileName = null;
        }
    }

    onChangeDropdown = (index, value, controlName) => {
        var item = this.state.form.veteranOwnerList[index];
        item[controlName] = value.value;

        this.props.onUpdateVeteranOwnerList(index, item);
    };

    downloadSF180 = () => {
        new API().download({
            storageToken: this.state.formSF180StorageToken,
            fileName: this.state.formSF180fileName
        });
    };

    handleAddPhone = (index) => {
        let form = this.state.form;

        form.veteranOwnerList[index].phones.push({
            phoneTypeCode: "MOBILE",
            number: "",
            extension: "",
            phoneId: -Math.abs(Date.now() | 0)
        });

        this.setState({ form });
    }

    handleRemovePhone = (veteranIndex, phoneIndex) => {
        let form = this.state.form;

        form.veteranOwnerList[veteranIndex].phones[phoneIndex].number = "";
        form.veteranOwnerList[veteranIndex].phones.splice(phoneIndex, 1);

        this.setState({ form });
    }

    handlePhoneChange = (value, veteranIndex, phoneIndex) => {
        let form = this.state.form;

        form.veteranOwnerList[veteranIndex].phones[phoneIndex] = value;

        this.setState({ form });
    }

    renderPhones = (index) => {
        var disabledItem = this.props.isRenewal && !this.state.form.veteranOwnerList[index].fromRenewal;
        
        if (this.state.form.veteranOwnerList[index].phones.length === 0)
            this.handleAddPhone(index);

        return this.state.form.veteranOwnerList[index].phones.map((p, i) =>
            <div key={p.phoneId} className="form-inline" >
                <PhoneBox
                    value={p}
                    showExtension
                    onChange={(v) => this.handlePhoneChange(v, index, i)}
                    disabled={disabledItem} />
                <Button
                    bsStyle="link"
                    title="Remove Phone"
                    disabled={disabledItem}
                    onClick={() => this.handleRemovePhone(index, i)}><FontAwesomeIcon icon={faTimes} /></Button>
            </div>
        );
    }

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }

    renderRenewalItem(item, index) {
        let me = this;
        item.provideOwnerLoginPermission = item.provideOwnerLoginPermission === null ? false : item.provideOwnerLoginPermission;
        item.isOwnerVeteran = item.isOwnerVeteran === null ? false : item.isOwnerVeteran;

        return(<Row>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label htmlFor='ownerSSN' tip={me.setTip(TooltipCode.VETERAN.OWNERSSN)} required>
                                    Owner SSN
                                </Label>
                                <MaskedBox
                                    disabled
                                    name='ownerSSN'
                                    placeholder='Owner SSN'
                                    mask='999-99-9999'
                                    alwaysShowMask={false}
                                    maskChar=''
                                    value={item.ownerSSN}
                                    onChange={e => me.onChange(index, e, 'ownerSSN')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label htmlFor='firstName' tip={me.setTip(TooltipCode.VETERAN.FIRSTNAME)} required>
                                    First Name
                                </Label>
                                <TextBox
                                    name='firstName'
                                    placeholder="First Name"
                                    maxLength={40}
                                    value={item.firstName}
                                    onChange={e => me.onChange(index, e, 'firstName')}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label htmlFor='lastName' tip={me.setTip(TooltipCode.VETERAN.LASTNAME)} required>
                                    Last Name
                                </Label>
                                <TextBox
                                    name='lastName'
                                    placeholder="Last Name"
                                    maxLength={40}
                                    value={item.lastName}
                                    onChange={e => me.onChange(index, e, 'lastName')}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label htmlFor='businessHeldPercent' tip={me.setTip(TooltipCode.VETERAN.COMPANYHELD)} required>Percent of Company Held</Label>
                                <PercentageBox
                                    managed={true}
                                    name='businessHeldPercent'
                                    placeholder="% Held"
                                    value={item.businessHeldPercent}
                                    onBlur={e => me.onHeldPercentBlur(index, e, 'businessHeldPercent')}
                                    onFieldChange={e => me.onChange(index, e, 'businessHeldPercent')}
                                    precision={2}
                                    style={{ width: '80px' }}
                                    maxLength='6'
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
                <Col md={1}></Col>
                <Col md={5}>
                    {item.isOwnerVeteran || item.order === 0 ? (
                        <React.Fragment>
                            <FormGroup>
                                <Label tip={me.setTip(TooltipCode.VETERAN.PROOFCITIZENSHIP)} required>Proof of U.S. Citizenship Upload</Label>
                                <DocumentUpload
                                    storageToken={item.citizenshipProofStorageToken}
                                    fileName={item.citizenshipProofFileName}
                                    onChange={e => me.handleCitizenshipProofUploadChange(index, e)}
                                    disabled={!item.citizenshipProofMissingFromOriginalApp}
                                />
                            </FormGroup>
                            {item.sdvet ? (
                                // GAP-1403-01: same badge/message pattern confirmed for the
                                // Renewal One-Sheet (VeteranOwnersSection.js), applied here so the
                                // classic wizard no longer visually contradicts the backend
                                // exemption it already honors (SaveVeteranOwnerInfo/
                                // ValidateVeteranOwnerInfoRequiredFields).
                                <SdvetNotice />
                            ) : (
                                <React.Fragment>
                                    <FormGroup>
                                        <Label htmlFor='veteranServiceConnectedDisabled' tip={me.setTip(TooltipCode.VETERAN.VETERANSERVICEDISABLED)}>Does the Veteran have a Service Connected Disability?</Label>
                                        <Switch
                                            disabled={false}
                                            name='veteranServiceConnectedDisabled'
                                            labelLeft='No'
                                            labelRight='Yes'
                                            bsStyle='primary'
                                            value={item.veteranServiceConnectedDisabled}
                                            onChange={e => me.onChange(index, e, 'veteranServiceConnectedDisabled')}
                                        />
                                    </FormGroup>
                                    {item.veteranServiceConnectedDisabled ? (
                                        <FormGroup>
                                            <Label tip={me.setTip(TooltipCode.VETERAN.BENEFITVETLETTER)}>
                                                Benefit Verification Letter from EBenefits or VA - <font style={{color:"red"}}>Do not Upload CVE Certificate</font>
                                                &nbsp;<span className="required-indicator">*</span>
                                            </Label>
                                            <DocumentUpload
                                                storageToken={item.benefitVerificationLetterStorageToken}
                                                fileName={item.benefitVerificationLetterFileName}
                                                onChange={e => me.handleBenefitVerificationLetterUploadChange(index, e)}
                                            />
                                        </FormGroup>
                                    ) : null}
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    ) : null}
                </Col>
            </Row>);
    }

    renderItem(item, index) {
        let me = this;
        item.provideOwnerLoginPermission = item.provideOwnerLoginPermission === null ? false : item.provideOwnerLoginPermission;
        item.isOwnerVeteran = item.isOwnerVeteran === null ? false : item.isOwnerVeteran;
        var disabledItem = me.props.isRenewal && !item.fromRenewal;

        return(<Row>
            <Col md={5}>
                { !disabledItem ?
                    <React.Fragment>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label htmlFor='ownerSSN' tip={me.setTip(TooltipCode.VETERAN.OWNERSSN)} required>
                                        Owner SSN
                                    </Label>
                                    <MaskedBox
                                        disabled={disabledItem}
                                        name='ownerSSN'
                                        placeholder='Owner SSN'
                                        mask='999-99-9999'
                                        alwaysShowMask={false}
                                        maskChar=''
                                        value={item.ownerSSN}
                                        onChange={e => me.onChange(index, e, 'ownerSSN')}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label htmlFor='firstName' tip={me.setTip(TooltipCode.VETERAN.FIRSTNAME)} required>
                                        First Name
                                    </Label>
                                    <TextBox
                                        name='firstName'
                                        placeholder="First Name"
                                        maxLength={40}
                                        value={item.firstName}
                                        onChange={e => me.onChange(index, e, 'firstName')}
                                        disabled={disabledItem}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor='lastName' tip={me.setTip(TooltipCode.VETERAN.LASTNAME)} required>
                                        Last Name
                                    </Label>
                                    <TextBox
                                        name='lastName'
                                        placeholder="Last Name"
                                        maxLength={40}
                                        value={item.lastName}
                                        onChange={e => me.onChange(index, e, 'lastName')}
                                        disabled={disabledItem}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </React.Fragment>
                : null}
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label htmlFor='title' tip={me.setTip(TooltipCode.VETERAN.TITLE)} required>
                                Title
                            </Label>
                            <TextBox name='title'
                                placeholder="Title"
                                maxLength={25}
                                value={item.title}
                                onChange={e => me.onChange(index, e, 'title')}
                                disabled={disabledItem} />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label htmlFor='birthDate' tip={me.setTip(TooltipCode.VETERAN.DATEOFBIRTH)} required>Date of Birth</Label>
                            <DatePicker
                                managed={true}
                                placeholder='Select Date'
                                isValidDate={(currentDate) => {return currentDate.isBefore( Moment() );}}
                                value={item.birthday}
                                onBlur={e => me.onDateBlur(index, e, 'birthday')}
                                onFieldChange={e => me.onChange(index, e, 'birthday')}
                                showTime={false}
                                className='dpThin'
                                disabled={disabledItem}
                                ref={`birthday_${index}`}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label htmlFor='genderCode' tip={me.setTip(TooltipCode.VETERAN.GENDERCODE)} required>Gender</Label>
                            <GenderCombo
                                name='genderCode'
                                placeholder="Gender"
                                value={item.genderCode}
                                onChange={e => me.onChangeDropdown(index, e, 'genderCode')}
                                disabled={disabledItem}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label htmlFor='ethnicityId' tip={me.setTip(TooltipCode.VETERAN.ETHNICITY)} required>Ethnicity</Label>
                            <EthnicityCombo
                                name='ethnicityId'
                                placeholder="Ethnicity"
                                value={item.ethnicityId}
                                onChange={e => me.onChangeDropdown(index, e, 'ethnicityId')}
                                disabled={disabledItem}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <Label htmlFor='email' tip={me.setTip(TooltipCode.VETERAN.EMAIL)} required>
                                Email
                            </Label>
                            <EmailBox
                                name='email'
                                placeholder='Email'
                                value={item.email}
                                onChange={e => me.onChange(index, e, 'email')}
                                disabled={disabledItem}
                            />
                        </FormGroup>
                        { !disabledItem ?
                            <FormGroup>
                                <Label htmlFor='businessHeldPercent' tip={me.setTip(TooltipCode.VETERAN.COMPANYHELD)} required>Percent of Company Held</Label>
                                <PercentageBox
                                    managed={true}
                                    name='businessHeldPercent'
                                    placeholder="% Held"
                                    value={item.businessHeldPercent}
                                    onFieldChange={e => me.onChange(index, e, 'businessHeldPercent')}
                                    precision={2}
                                    style={{ width: '80px' }}
                                    maxLength='6'
                                    disabled={disabledItem}
                                />
                            </FormGroup>
                        : null }
                        <FormGroup>
                            <Label required htmlFor="phones" tip={me.setTip(TooltipCode.VETERAN.PHONENUMBER)} >Phone Number(s)</Label>
                            {me.renderPhones(index)}
                        </FormGroup>
                        {me.state.form.veteranOwnerList[index].phones.length < 5 &&
                            <Button bsStyle="default"
                                bsSize="xsmall"
                                className="pull-right"
                                disabled={disabledItem}
                                onClick={() => me.handleAddPhone(index)}>Add Phone<Glyphicon glyph="plus" style={{ marginLeft: 10 }} />
							</Button>
                        }
                    </Col>
                </Row>
            </Col>
            <Col md={1}></Col>
            <Col md={5}>
                <FormGroup>
                    <Label tip={me.setTip(TooltipCode.VETERAN.OWNERRESUME)} required>Owner Resume</Label>
                    <DocumentUpload
                        storageToken={item.ownerResumeStorageToken}
                        fileName={item.ownerResumeFileName}
                        onChange={e => me.handleOwnerResumeUploadChange(index, e)}
                        disabled={disabledItem}
                    />
                </FormGroup>
                {item.order > 0 ? (
                    <FormGroup>
                        <Label htmlFor='isOwnerVeteran' tip={me.setTip(TooltipCode.VETERAN.OWNERVETERAN)}>Is this Owner a Veteran?</Label>
                        <Switch
                            name='isOwnerVeteran'
                            labelLeft='No'
                            labelRight='Yes'
                            bsStyle='primary'
                            value={item.isOwnerVeteran}
                            onChange={e => me.onChange(index, e, 'isOwnerVeteran')}
                            disabled={disabledItem}
                        />
                    </FormGroup>
                ) : null}
                {index > 0 && !item.isOwnerVeteran ? (
                    <FormGroup>
                        <Label tip={me.setTip(TooltipCode.VETERAN.NONVETERANCONTRIB)} required>Non-Veteran Contributions</Label>
                        <DocumentUpload
                            storageToken={item.nonVeteranContributionsStorageToken}
                            fileName={item.nonVeteranContributionsFileName}
                            onChange={e => me.handleNonVeteranContributionsUploadChange(index, e)}
                            disabled={disabledItem}
                        />
                    </FormGroup>
                ) : null}
                {item.isOwnerVeteran || item.order === 0 ? (
                    <React.Fragment>
                        <FormGroup>
                            <Label htmlFor='serviceBranchId' tip={me.setTip(TooltipCode.VETERAN.SERVICEBRANCH)} required>
                                Branch of Service
                            </Label>
                            <ServiceBranchCombo
                                name='serviceBranchId'
                                placeholder="Branch of Service"
                                value={item.serviceBranchId}
                                onChange={e => me.onChangeDropdown(index, e, 'serviceBranchId')}
                                disabled={disabledItem}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label tip={me.setTip(TooltipCode.VETERAN.SF180UPLOAD)} required>SF180 Upload</Label>
                            <Button bsStyle='default' bsSize='small' onClick={() => me.downloadSF180()} style={{ marginLeft: 10 }}>
                                <FontAwesomeIcon icon={faExclamationTriangle} size='lg' color="orange" />
                                &nbsp;&nbsp;Click here to download SF180 Form
                                </Button>
                            {me.setTip(TooltipCode.VETERAN.SF180FORM) && <Tooltip tip={me.setTip(TooltipCode.VETERAN.SF180FORM)} />}
                            <DocumentUpload
                                storageToken={item.sF180StorageToken}
                                fileName={item.sF180FileName}
                                onChange={e => me.handleSF180UploadChange(index, e)}
                                disabled={disabledItem}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor='sF180SentDate' tip={me.setTip(TooltipCode.VETERAN.SF180SENTDATE)} required>
                                Date SF180 was sent via postal mail to Custodian(s)
                            </Label>
                            <DatePicker
                                managed={true}
                                placeholder="Sent date"
                                isValidDate={(currentDate) => {return currentDate.isBefore( Moment() );}}
                                value={item.sF180SentDate}
                                onBlur={e => me.onDateBlur(index, e, 'sF180SentDate')}
                                onFieldChange={e => me.onChange(index, e, 'sF180SentDate')}
                                showTime={false}
                                className='dpThin'
                                disabled={disabledItem}
                                ref={`sF180SentDate_${index}`}
                            />
                            <CheckBox
                                inline
                                value={item.sF180Confirmation}
                                name='sF180Confirmation'
                                disabled={disabledItem || !item.sF180StorageToken}
                                label='I confirm that I have carefully reviewed, signed, and sent the original NVBDC SF180 Request Form to the appropriate military records location'
                                onChange={e => me.handleConfirmF180(index, e)}
                            />
                        </FormGroup>
                        { !disabledItem ?
                            <React.Fragment>
                                <FormGroup>
                                    <Label tip={me.setTip(TooltipCode.VETERAN.PROOFCITIZENSHIP)} required>Proof of U.S. Citizenship Upload</Label>
                                    <DocumentUpload
                                        storageToken={item.citizenshipProofStorageToken}
                                        fileName={item.citizenshipProofFileName}
                                        onChange={e => me.handleCitizenshipProofUploadChange(index, e)}
                                        disabled={disabledItem}
                                    />
                                </FormGroup>
                                {item.sdvet ? (
                                    // GAP-1403-01: same badge/message pattern confirmed for the
                                    // Renewal One-Sheet (VeteranOwnersSection.js), applied here so
                                    // the classic wizard no longer visually contradicts the backend
                                    // exemption it already honors (SaveVeteranOwnerInfo/
                                    // ValidateVeteranOwnerInfoRequiredFields).
                                    <SdvetNotice />
                                ) : (
                                    <React.Fragment>
                                        <FormGroup>
                                            <Label htmlFor='veteranServiceConnectedDisabled' tip={me.setTip(TooltipCode.VETERAN.VETERANSERVICEDISABLED)}>Does the Veteran have a Service Connected Disability?</Label>
                                            <Switch
                                                disabled={false}
                                                name='veteranServiceConnectedDisabled'
                                                labelLeft='No'
                                                labelRight='Yes'
                                                bsStyle='primary'
                                                value={item.veteranServiceConnectedDisabled}
                                                onChange={e => me.onChange(index, e, 'veteranServiceConnectedDisabled')}
                                            />
                                        </FormGroup>
                                        {item.veteranServiceConnectedDisabled ? (
                                            <FormGroup>
                                                <Label tip={me.setTip(TooltipCode.VETERAN.BENEFITVETLETTER)}>
                                                    Benefit Verification Letter from EBenefits or VA - <font style={{color:"red"}}>Do not Upload CVE Certificate</font>
                                                    &nbsp;<span className="required-indicator">*</span>
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={item.benefitVerificationLetterStorageToken}
                                                    fileName={item.benefitVerificationLetterFileName}
                                                    onChange={e => me.handleBenefitVerificationLetterUploadChange(index, e)}
                                                />
                                            </FormGroup>
                                        ) : null}
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        : null }
                    </React.Fragment>
                ) : null}
            </Col>
        </Row>);
    }

    render() {
        
        let me = this;
        let rows = this.state.form.veteranOwnerList.map(function (item, index) {

            item.provideOwnerLoginPermission = item.provideOwnerLoginPermission === null ? false : item.provideOwnerLoginPermission;
            item.isOwnerVeteran = item.isOwnerVeteran === null ? false : item.isOwnerVeteran;

            return (
                <div key={item.veteranOwnerId}>
                    {me.props.isRenewal && !item.fromRenewal ?
                        <React.Fragment>
                            <Row>
                                <Col md={12}>
                                    {me.renderRenewalItem(item, index)}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={11}>
                                    <div className="box box-secondary" style={{ boxShadow: "none" }}>
                                        <Row>
                                            <Col md={12}>
                                                <Label>
                                                    <a style={{ cursor: 'pointer', color: "#3c8dbc", fontSize: '16px' }} onClick={() => me.onClickDetails(index)}>
                                                        &nbsp;
                                                        {item.veteranDetailHide ?
                                                            <FontAwesomeIcon icon={faChevronDown} style={{ width:12, padding: 0 }} />
                                                        :
                                                            <FontAwesomeIcon icon={faChevronRight} style={{ width:12, padding: 0 }} />
                                                        }
                                                        <em>
                                                            &nbsp;&nbsp; {item.firstName} {item.lastName} details from original certification
                                                        </em>
                                                    </a>
                                                </Label>
                                                <br />
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <div hidden={!item.veteranDetailHide}>
                                <Row>
                                    <Col md={12}>
                                        <hr style={{ marginTop: 0 }}/>
                                        {me.renderItem(item, index)}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={11}>
                                        <hr />
                                    </Col>
                                </Row>
                            </div>
                        </React.Fragment>
                    :
                        <Row>
                            <Col md={12}>
                                {me.renderItem(item, index)}
                            </Col>
                        </Row>
                    }

                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                {(index === me.state.form.veteranOwnerList.length - 1) ? (
                                    <Button onClick={() => me.props.addVeteranOwner(me.state.form.veteranOwnerList.length)} bsSize='xsmall'>
                                        Add another Owner
                                    </Button>
                                ) : null}
                                &nbsp;&nbsp;
                                {index > 0 ? (
                                    <Button onClick={() => me.onDeleteVeteranOwner(index)} bsSize='xsmall'>
                                        Remove Owner
                                    </Button>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>
                    {me.state.form.veteranOwnerList.length !== 1 ? 
                        <Row>
                            <Col md={12}>
                                <hr style={{ border : "1px solid #3c8dbc", backgroundColor: "#3c8dbc" }} />
                            </Col>
                        </Row>
                    : null }
                </div>
            );
        });

        return <React.Fragment>{rows}</React.Fragment>;
    }
}

export default VeteranOwnerList;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/veteranOwnerInfo/VeteranOwnerList.js